import React, { useEffect, useState, useRef, use } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import "./PersonalScheduleItem.scss"
import { secondsToTime } from '../../../helpers/datetime';

const PersonalScheduleItem = ({ slot = {}, elem = null, salon = null, ref = null, nextMonth = false }) => {
    const slots = useSelector(state => state.schedule.slots);
    const nextSlots = useSelector(state => state.personal.nextSlots);
    const specialists = useSelector(state => state.schedule.specialists);
    const positions = useSelector(state => state.specialists.positions)

    const [coWorkersList, setCoWorkersList] = useState([]);
    const [coWorkersString, setCoWorkersString] = useState('');
    const [currentSpecialist, setCurrentSpecialist] = useState(null);
    const currentSlots = nextMonth ? nextSlots : slots

    useEffect(() => {
        let position = positions.find(el => el.id == slot.position)
        
        setCurrentSpecialist(position);        
    }, [slot, positions])
    
    // Находим список специалистов на одной смене
    useEffect(() => {
        let coWorkers = currentSlots.filter(el => el.date_format == elem.date_format && el.worker_id != slot?.worker_id)
        coWorkers = coWorkers.filter(el => el.site_id == salon?.id)

        const specialistIds = [];

        coWorkers.forEach(worker => {
            specialistIds.push(specialists.filter(specialist => specialist.id == worker?.worker_id)[0])
        });

        setCoWorkersList(specialistIds)
    }, [currentSlots, specialists])

    // Создаём красивую строку с coworkerами
    useEffect(() => {
        let coWorkersValue = '';

        coWorkersList.forEach((worker, index) => {
            if (index == coWorkersList.length - 1) {
                coWorkersValue = coWorkersValue + worker?.name
            } else if (index == coWorkersList.length - 2) {
                coWorkersValue = coWorkersValue + worker?.name + ' и '
            } else {
                coWorkersValue = coWorkersValue + worker?.name + ', '
            }
        })

        setCoWorkersString(coWorkersValue)
    }, [coWorkersList])

    return (
        <div ref={ref} className={"personal__schedule-item" + (elem.is_today ? ' today' : '')}>
            {slot != 'weekend' ?
                <div className={'personal__schedule-item-string personal__schedule-item-work' + (slot.substitute !== null && slot.substitute !== 0 ? ' substitute' : '')}>
                    {elem.is_today &&
                        <div className="personal__schedule-item-today">Сегодня</div>
                    }
                    <div className="personal__schedule-item-day">{elem.day} {elem.month}, {elem.day_of_week},</div>
                    <div className="personal__schedule-item-time">{secondsToTime(slot.time_start)} – {secondsToTime(slot.time_end)},</div>
                    <div className="personal__schedule-item-salon">{salon && salon.description},</div>
                    <div className="personal__schedule-item-position">{currentSpecialist && currentSpecialist.name}</div>
                    {coWorkersList.length > 0 &&
                        <div className="personal__schedule-item-coworkers">
                            <span className="personal__schedule-item-coworkers--text">
                                Вместе с <span>{coWorkersString}</span>
                            </span>
                        </div>
                    }
                </div> :
                <div className='personal__schedule-item-string personal__schedule-item-weekend'>
                    {elem.is_today &&
                        <div className="personal__schedule-item-today">Сегодня</div>
                    }
                    <div className="personal__schedule-item-day">{elem.day} {elem.month},</div>
                    <div className="personal__schedule-item-weekend--text">Выходной</div>
                </div>

            }
        </div>
    );
};

export default PersonalScheduleItem;
